import { computed } from "vue";
import { useClientStore } from "../store/client";
import { useServiceStore } from "../store/service";

export function usePermissions() {
  const service = useServiceStore();
  const client = useClientStore();

  const isAdmin = computed(() => client.me?.jwt.hasAllServiceAccess);
  const permissionsOwner = computed(() => service.ctx.sys?.permissionsOwner?.userName);
  const isServiceOwner = computed(() => client.me?.jwt.username === permissionsOwner.value);

  return { isAdmin, permissionsOwner, isServiceOwner };
}
